import { IconShieldCog } from '@tabler/icons-react'
import { FC, useState, useEffect } from 'react'
import { PrimaryButton } from '../../atoms/buttons/PrimaryButton'
import { SecondaryButton } from '../../atoms/buttons/SecondaryButton'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from '../../atoms/dialog'
import Typography from '../../atoms/Typography'
import TenantAccessSelector from '../../molecules/TenantAccessSelector'
import { api } from 'src/api/root'
import { LearningMaterial } from 'src/types/superadmin'

interface Props {
  material: LearningMaterial
}

const EditMaterialAccess: FC<Props> = ({ material }) => {
  const [opened, setOpened] = useState<boolean>(false)
  const [selectedTenants, setSelectedTenants] = useState<string[]>([])

  const currentTenantIds = material.allowedTenants.map((tenant) => tenant.id)

  const { mutate: updateTenants, isLoading } = api.superAdmin.updateLearningMaterialTenants.useMutation()

  useEffect(() => {
    setSelectedTenants(currentTenantIds)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [material.allowedTenants])

  const handleDialogChange = (open: boolean) => {
    setOpened(open)
    if (!open) {
      setSelectedTenants(currentTenantIds)
    }
  }

  const handleSubmit = () => {
    updateTenants(
      { id: material.id, tenantIds: selectedTenants },
      {
        onSuccess: () => setOpened(false),
      },
    )
  }

  return (
    <Dialog open={opened} onOpenChange={handleDialogChange}>
      <DialogTrigger className="flex h-11 w-11 items-center justify-center rounded-[8px] text-light-green-500 transition-all hover:cursor-pointer hover:bg-light-green-500 hover:text-white active:scale-95">
        <IconShieldCog size={24} />
      </DialogTrigger>
      <DialogContent className="sm:max-w-[800px]">
        <DialogHeader>
          <DialogTitle>
            <Typography variant="xl">Material Access Management</Typography>
          </DialogTitle>
        </DialogHeader>
        <TenantAccessSelector
          selectedTenantIds={selectedTenants}
          onChange={setSelectedTenants}
          currentTenantIds={currentTenantIds}
          enabled={opened}
        />
        <DialogFooter className="sm:justify-end sm:space-x-4">
          <SecondaryButton onClick={() => setOpened(false)}>Cancel</SecondaryButton>
          <PrimaryButton onClick={handleSubmit} isLoading={isLoading}>
            Save Changes
          </PrimaryButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default EditMaterialAccess
